import { FlexibleTemplateComponent } from 'libs/templates/flexible/flexible.component';

export const SharedAdminRoutes = [
  { path: '', component: FlexibleTemplateComponent, data: { pageWidth: 'full', page: 'home-shared-admin', contentGroup: 'member-home-shared-admin' } },
  { path: 'home', redirectTo: '' },
  { path: 'virtual-care', component: FlexibleTemplateComponent, data: { pageWidth: 'full', page: 'virtualcare-shared-admin', contentGroup: 'member-virtualcare-shared-admin' } },
  { path: 'virtualcare', component: FlexibleTemplateComponent, data: { pageWidth: 'full', page: 'virtualcare-shared-admin', contentGroup: 'member-virtualcare-shared-admin' } },
];
